import React from 'react';
import styled from 'styled-components';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TextContainer } from './TextContainer';
import media from '../../utils/media';
import { COLOR_MAPPING_INFOGRAPHIC } from '../../constants';
import { isFieldValid } from '../../utils/validation';
// TODO: consolidate all similar Graphic Containers to one
const GraphicContainer = styled.div `
  background-color: ${({ theme }) => theme.primaryWhite};
  .item-container {
    border-bottom: 1px solid ${({ theme }) => theme.greyDarkMedium};
  }

  ${media.mobile} {
    margin: 0px 10px;
    width: calc(100% - 20px);
  }
  ${media.mobileL} {
    margin: 0;
    width: 100%;
  }
`;
const ItemContainer = styled.div `
  display: flex;
  align-items: center;
  max-width: 540px;
  padding: 30px 0px 30px 0px;

  ${media.tablet} {
    padding: 30px 0px 30px 0px;
  }

  ${media.mobile} {
    padding: 30px 10px 0px 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
const StaticNumberContainer = styled.div `
  display: flex;
  justify-content: flex-end;
  max-width: 177px;
  width: 100%;
  ${media.mobile} {
    justify-content: flex-start;
  }
`;
const ValueTextContainer = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 185px;
  ${media.mobile} {
    margin-bottom: 10px;
  }
`;
const ValueText = styled(Text).attrs(() => ({
    tag: 'span',
})) `
  font-weight: 500;
  font-style: normal;
  font-size: 50px;
  line-height: 60px;
  color: ${COLOR_MAPPING_INFOGRAPHIC[0]};
  font-family: ${({ theme }) => theme.fontFamilyBase};
  text-align: right;
  height: 60px;
  ${media.mobile} {
    text-align: left;
  }
`;
export const StaticNumberGraphic = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { chartValue, graphicTitle, graphicBodyText } = fields;
    return (React.createElement(GraphicContainer, { className: "graphic-container static-number" },
        React.createElement(ItemContainer, { className: "item-container" },
            isFieldValid(chartValue) && (React.createElement(StaticNumberContainer, { className: "static-number-container" },
                React.createElement(ValueTextContainer, { className: "number-value-container" },
                    React.createElement(ValueText, { field: chartValue })))),
            React.createElement(TextContainer, { bodyText: graphicBodyText, title: graphicTitle, mobileAlignment: "Left" }))));
};
